import vex from 'vex-js'
import vexDialog from 'vex-dialog'

vex.registerPlugin(vexDialog)
vex.defaultOptions.className = 'modal'
vex.dialog.defaultOptions.showCloseButton = true
vex.defaultOptions.overlayClosesOnClick = false

export default vex
